module.exports = __webpack_public_path__ + "img/san.10c15b3b.png";